import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  UpdateContractTermsAndConditions,
  UpdateContractTermsAndConditionsVariables
} from '@/graphql/contracts/_generated_/updateContractTermsAndConditions.mutation';
import UpdateContractTermsAndConditionsMutation
  from '@/graphql/contracts/updateContractTermsAndConditions.mutation.gql';
import GetContractTermsAndConditionsQuery from '@/graphql/contracts/getContractTermsAndConditions.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { UpdateContractTermsAndConditionsInputType } from '@/graphql/contracts/_generated_/contracts';

export type UpdateContractTCsInput = Omit<UpdateContractTermsAndConditionsInputType, 'contractId'>;

export default function useUpdateContractTermsAndConditions(contractId: string) {
  const [_updateTCs, { loading }] = useMutation<
  UpdateContractTermsAndConditions,
  UpdateContractTermsAndConditionsVariables
  >(
    UpdateContractTermsAndConditionsMutation,
    {
      client: apolloClientContracts,
      refetchQueries: [
        {
          query: GetContractTermsAndConditionsQuery,
          variables: { contractId }
        }
      ],
      awaitRefetchQueries: true,
      onCompleted: () => notificationService.open({
        title: 'Update Contract T&Cs',
        text: 'Contract Terms & Conditions successfully updated',
        type: 'success'
      }),
    },
  );

  const updateContractTermsAndConditions = async (
    input: UpdateContractTCsInput,
    cbOnError?: () => void
  ) => {
    _updateTCs({
      variables: {
        input: {
          contractId,
          ...input
        }
      },
      onError: (err) => {
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        });

        cbOnError?.();
      }
    });
  };

  return {
    updateContractTermsAndConditions,
    isLoadingUpdate: loading
  } as const;
}
